import { productPriceCurrencyPositionEnum } from 'src/interfaces';
import { GcfMockData } from 'src/utils/gcf-helper';

import { CommonFormProps, ISize } from '../FormSelector.interface';

interface Ifont {
  font?: string;
  fontSize?: string;
  lineHeight?: string;
  letterSpacing?: string;
  color?: string;
  enable?: boolean;
}
interface Ilabel extends Ifont {
  label: string;
}

interface ConfirmationTotalConfigInterface
  extends CodTotalConfigInterface,
    BoxPadding {
  title?: Ilabel;
  donate?: Ilabel;
}

interface ConfirmationTotalConfigInterface
  extends CodTotalConfigInterface,
    BoxPadding {
  title?: Ilabel;
  donate?: Ilabel;
}
interface Images {
  largeImage: {
    background: string;
  };
  smallImage: {
    background: string;
  };
}

interface IBanner {
  images: Images;
  font: string;
  color: string;
  active: boolean;
  showBannerImage?: boolean;
  backgroundColor?: string;
  alignment?: string;
  top?: string;
  left?: string;
  label?: string;
}

interface IReview {
  banner: IBanner;
}

export interface ConfirmationHeaderConfigInterfaceUS {
  review: IReview;
}
interface ConfirmationBodyConfigInterface {
  backgroundColor: string;
  font: string;
  color: string;
  discount: CodDiscountInterface;
}
interface ConfirmationUSBodyConfigInterface
  extends Omit<ConfirmationBodyConfigInterface, 'backgroundColor'>,
    BoxPadding {
  styleConfig?: CodBodyStyleConfigInterface;
  background?: string;
}

export interface ConfirmationUSConfigInterface {
  header: ConfirmationHeaderConfigInterfaceUS;
  footer: CodFooterConfig;
  total: ConfirmationTotalConfigInterface;
  body: ConfirmationUSBodyConfigInterface;
  topMessage: CodTopCustomMessageInterface;
}

interface Ifonts {
  font: string;
  color: string;
}

interface LmsFeatureFlagsInterface {
  originalPriceCalculation: boolean;
}

interface ImodifierLabels {
  NO: string;
  LIGHT: string;
  ONLY: string;
  LIGHTONLY: string;
}

interface IglobalSetting extends Ifonts {
  displayVoidedItems?: boolean;
  modifierLabels?: ImodifierLabels;
  featureFlags?: LmsFeatureFlagsInterface;
  productPriceCurrency?: string;
  productFullPriceOnly?: boolean;
  productPriceCurrencyPosition?: productPriceCurrencyPositionEnum;
  productPriceDecimalSeparator?: string;
}

interface CodCommonTopCustomMessageInterface {
  message: string;
  color?: string;
  backgroundColor?: string;
  boxPadding?: {
    paddingLeft: string;
    paddingRight: string;
    paddingTop: string;
    paddingBottom: string;
  };
}

interface CodDiscountInterface {
  dealUsed: {
    label: string;
  };
  reward: {
    label: string;
  };
}

interface CodCommonBodyConfigInterface {
  backgroundColor?: string;
  font: string;
  color: string;
  denseView: boolean;
  promoLabel?: string;
  orderSelection: {
    backgroundColor: string;
    color: string;
  };
  discount: CodDiscountInterface;
}

interface CodBodyStyleConfigInterface {
  product: Ifont;
  subProduct: Ifont;
  discounts: DiscountStyleConfigInteface;
}

interface PositionInterface {
  left: number;
  top: number;
  zIndex?: number;
}

type BoxPaddingProps = {
  paddingTop?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  paddingRight?: string;
};

type BoxPadding = {
  boxPadding?: BoxPaddingProps;
};

interface MessageBoxStyle {
  border?: string;
  borderRadius?: string;
  padding?: string;
  background?: string;
}

export enum MessageConfigTypes {
  ICON_AND_TEXT = 'iconAndText',
  IMAGE = 'image',
}

export enum BannerImageType {
  LARGE_IMAGE = 'largeImage',
  SMALL_IMAGE = 'smallImage',
}

interface IIconAndText extends Ifont {
  icon: string;
  label: string;
}

export interface IMessageConfig extends PositionInterface {
  enabledTypeKey: MessageConfigTypes;
  image?: string;
  iconAndText?: IIconAndText;
  wrapperStyle?: MessageBoxStyle;
}

interface DiscountStyle extends Ifont {
  border?: string;
  borderRadius?: string;
  backgroundColor?: string;
}

interface DiscountStyleConfigInteface {
  label: DiscountStyle;
  price: DiscountStyle;
}

interface CodHeaderConfigInterface extends BoxPadding {
  order: Ilabel & { border: string };
  pagination?: Ifont;
  background?: string;
}

export interface CodFooterConfig extends BoxPadding {
  background?: string;
  knownCustomer: CodKnownCustomerSchema;
  unknownCustomer: IMessageConfig[];
}

interface CodKnownCustomerSchema {
  linkedPayment: IMessageConfig[];
  unlinkedPayment: IMessageConfig[];
}
interface CodBodyConfigInterface
  extends Omit<CodCommonBodyConfigInterface, 'denseView' | 'orderSelection'> {
  background?: string;
  styleConfig?: CodBodyStyleConfigInterface;
  orderSelection?: {
    backgroundColor: string;
    color: string;
  };
}
interface CodTotalConfigInterface extends BoxPadding {
  background?: string;
  total: Ilabel;
  save: Ilabel;
  tax: Ilabel;
}

interface CodTopCustomMessageInterface
  extends Omit<CodCommonTopCustomMessageInterface, 'backgroundColor'> {
  background?: string;
  hideRmhcMessage?: boolean;
}

interface CodLaypoutConfigInterface {
  height?: string;
  width?: string;
  heightOffset?: string;
}

export interface CodConfigInterface {
  header: CodHeaderConfigInterface;
  layoutConfig?: CodLaypoutConfigInterface;
  body: CodBodyConfigInterface & BoxPadding;
  total: CodTotalConfigInterface;
  topMessage?: CodTopCustomMessageInterface;
  footer: CodFooterConfig;
}

export interface CodGlobalSetting extends IglobalSetting {
  background?: string;
  confirmationBackground?: string;
}

interface CodSettingsInterface {
  globalSetting: CodGlobalSetting;
  codSetting: CodConfigInterface;
  confirmSetting: ConfirmationUSConfigInterface;
}

export enum BackgroundColor {
  GOLD = 'linear-gradient(270deg, #FFBC0D 0%, #FFDF1E 100%)',
  BLACK = 'linear-gradient(270deg, #000000 0%, #434040 100%)',
}

export enum DividerColor {
  WHITE = '#FFFFFF',
  YELLOW = '#FFBC0D',
}
export interface CodDataInterface {
  codSettings: CodSettingsInterface;
}

export interface CODFormProps extends CommonFormProps<CodDataInterface> {
  setSize: React.Dispatch<React.SetStateAction<ISize | undefined>>;
  setOrderType: React.Dispatch<React.SetStateAction<GcfMockData>>;
}

export type HandleOnChangeType = (
  key: string | string[],
  value: unknown | any[],
  fieldOnChange?: any,
) => void;

export enum PaymentTypes {
  LINKED_PAYMENT = 'linkedPayment',
  UNLINKED_PAYMENT = 'unlinkedPayment',
}
export enum TAB_VALUES {
  COD = 'COD',
  OCD = 'OCD',
}
